import { MessageCircle } from "lucide-react";
import { useStorePicker } from "../hooks/useStorePicker";

export const WhatsAppFloat = () => {
  const { open } = useStorePicker();
  return (
    <button
      type="button"
      onClick={() => open("whatsapp")}
      className="hidden sm:flex fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group items-center justify-center"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-btn"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-1.5 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        Chat with us
      </span>
    </button>
  );
};
